import apiClient from './apiClient';
import { cachedGet } from './sessionConfigCache';

// ==================== Authentication ====================

// ==================== Password Reset API ====================

export const passwordResetAPI = {
  request: async (email) => {
    const response = await apiClient.post('/password-reset/request', { email });
    return response.data;
  },
  verify: async (token, signal) => {
    const response = await apiClient.post('/password-reset/verify', { token }, { signal });
    return response.data;
  },
  complete: async (token, password) => {
    const response = await apiClient.post('/password-reset/complete', { token, password });
    return response.data;
  },
};

// ==================== Staff Registration API ====================

export const staffRegisterAPI = {
  validateToken: async (token, signal) => {
    const response = await apiClient.get(`/staff-register/validate-token?token=${token}`, { signal, timeout: 15000 });
    return response.data;
  },
  register: async (data) => {
    const response = await apiClient.post('/staff-register/register', data);
    return response.data;
  },
  verifyEmail: async (data) => {
    const response = await apiClient.post('/staff-register/verify-email', data);
    return response.data;
  },
  resendCode: async (registrationId) => {
    const response = await apiClient.get(`/staff-register/resend-code/${registrationId}`);
    return response.data;
  },
  accept: async (token) => {
    const response = await apiClient.post('/staff-register/register/accept', { token });
    return response.data;
  },
};

// ==================== Team Registration API ====================

export const teamRegisterAPI = {
  complete: async (data) => {
    const response = await apiClient.post('/team/register/complete', data);
    return response.data;
  },
  accept: async (token) => {
    const response = await apiClient.post('/team/register/accept', { token });
    return response.data;
  },
};

// ==================== Authentication ====================

export const authAPI = {
  register: async (userData) => {
    const response = await apiClient.post('/auth/register', userData);
    return response.data;
  },

  // Register staff or vendor directly (without invitation link)
  registerStaffOrVendor: async (userData) => {
    const response = await apiClient.post('/auth/register-staff-vendor', userData);
    return response.data;
  },

  login: async (credentials) => {
    const response = await apiClient.post('/auth/login', credentials);
    return response.data;
  },

  getMe: async () => cachedGet('auth/me', async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  }),

  updateMe: async (userData) => {
    const response = await apiClient.put('/auth/me', userData);
    return response.data;
  },

  uploadAvatar: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/auth/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
